module.exports = __webpack_public_path__ + "img/community-stock.53134f67.jpg";